import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { Badge, Checkbox, Popover, Space, Input, Card, Empty } from 'antd';
import ActivityTimeLine from "../../common/ActivityStream/ActivityTimeLine";
import { modifyTimezoneString } from "../../components/HR/TimeClock/Util";
import Config from '../../config.json'
import axios from "axios";
const { Search } = Input;

const DealActivity = ({jobData, allUsers}) => {
  const bottomRef = useRef(null);
  const [activitiyData, setActivityData] = useState([]);
  const [apiResponse, setApiResponse] = useState([]);
  const [items, setItems] = useState([]);
  const history = useHistory();
  const [selectedActivityFilter, setSelectedActivityFilter] = useState([]);
  const [activityFilter, setActivityFilter] = useState({Sort:"DESC",SearchText:''});
  const getDealTimeline = () => {
    const backendUrl = Config.backend_aws_server_url + "catalyApi/workdrive";
    const apiUrl = `https://www.zohoapis.com/crm/v8/Deals/${jobData?.id}/__timeline?filters=%7B%22field%22%3A%7B%22api_name%22%3A%22source%22%7D%2C%22comparator%22%3A%22equal%22%2C%22value%22%3A%22crm_api%22%7D&include_inner_details=field_history.pick_list_values`;

    var config = {
        Type: "Get",
        url: apiUrl,
        method: "GET",
        headers: {
            'Authorization': localStorage.getItem('token')
        }
    };

    axios.post(backendUrl, { config: config })
        .then(function (res) {
            setApiResponse(res.data);
        })
        .catch(function (error) {
            console.error("Error fetching deal timeline:", error);
        });
  };

  useEffect(() => {
    getDealTimeline();
  }, [jobData?.id]);

  useEffect(() =>{
  if (!apiResponse) return;

  const formatted = convertZohoTimelineToActivityData(apiResponse, selectedActivityFilter);
  setActivityData(formatted)
},[apiResponse, selectedActivityFilter])

function convertZohoTimelineToActivityData(apiResponse, activityFilter) { 
  if (!apiResponse?.__timeline) return [];
    const normalizedFilters = activityFilter.map(f =>
    f.toLowerCase().replace(/_/g, " ")
  );
  return apiResponse.__timeline
    .filter(item => {
      if (!normalizedFilters.length) return true;
      const moduleName = item.record?.module?.api_name?.toLowerCase() || "";
      const rolesData = item.field_history?.[0]?._value.new || "(empty)";
      if (normalizedFilters.includes("notes") && moduleName === "notes") {
        const isRoleAction = rolesData.startsWith("Added___") || rolesData.startsWith("Updated___") ||
                              rolesData.startsWith("Deleted___");
        if(normalizedFilters.includes("roles")){
          return true;
        }
        if(isRoleAction){
          return false;
        }
        return true
      } else if(normalizedFilters.includes("roles") && moduleName === "notes"){
        if(rolesData.startsWith("Added___") || rolesData.startsWith("Updated___") || rolesData.startsWith("Deleted___")) {
          return true
        }
      }
      if (!item.field_history || !Array.isArray(item.field_history)) return false;
      const fieldApiNames = item.field_history.map(f =>
        f.api_name?.toLowerCase().replace(/_/g, " ")
      );
      return normalizedFilters.some(filterVal =>
        fieldApiNames.includes(filterVal)
      );
    }).map((item, index) => {
    const id = item.id || index + 1;
    const date = item.audited_time; // YYYY-MM-DD
    const type = item.action === "updated" 
      ? "Update" 
      : item.action === "added" 
      ? "Create" 
      : "Activity";

    let message = "";
    if (item.record?.module?.api_name === "Notes") {
        const noteContent = item.field_history?.[0]?._value.new || "(empty)";
        if(noteContent.startsWith("R___")){
         let firstMessage = noteContent.split("R___")[1];
         let noteParts = firstMessage.split("___R");
          message = `📝 Replied to Note - ${noteParts[0]} <br/> ${noteParts[1]}`;
        }else if(noteContent.startsWith("E___")){
          let firstMessage = noteContent.split("E___")[1];
          let noteParts = firstMessage.split("___E");
          message = `📝 Edited Note - <br/> From : ${noteParts[0]} <br/>To : ${noteParts[1].replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>')}`;
        }else if(noteContent.startsWith("D___")){
          let firstMessage = noteContent.split("D___")[1];
          message = `📝 Deleted Note - <br/> ${firstMessage}`; 
        }else if(noteContent.startsWith("Added___")){
          let firstMessage = noteContent.split("Added___")[1];
          message = `${firstMessage}`;
        }else if(noteContent.startsWith("Updated___")){
          let firstMessage = noteContent.split("Updated___")[1];
          message = `${firstMessage}`;
        } else  if(noteContent.startsWith("Deleted___")){
          let firstMessage = noteContent.split("Deleted___")[1];
          message = `${firstMessage}`;
        }else {
          message = `📝 Note added - <br/>${noteContent}`;
        }
    } else if (item.field_history && item.field_history.length > 0) {
      message = item.field_history
        .filter(field => field?.api_name != "Service_Requested_ID")
        .map(field => {
          let fieldName = field.api_name.replace(/_/g, " ");
          const oldVal = field._value?.old || "(empty)";
          const newVal = field._value?.new || "(empty)";
          if (fieldName == "Stage") {
            fieldName = "Status";
            const stageColors = {
              "Proposal": "#f5c72f",
              "On Hold": "#fd8989",
              "In Progress": "#25b52a",
              "Cancelled": "#dbdbdb",
              "Completed": "#add9ff"
            };

            const getBadge = (value) => {
              const bg = stageColors[value] || "#e0e0e0";
              return `<span style="
                background:${bg};
                border-radius:15px;
                padding:3px 10px;
                font-size:13px;
                font-weight:500;
                display:inline-block;
                color:#000;
                border:1px solid #cfcfcf;
              ">${value}</span>`;
            };
            return `${fieldName} was updated from ${getBadge(oldVal)} to ${getBadge(newVal)}`;
          } else {
          return `${fieldName} was updated from ${oldVal} to ${newVal}`;
          }
        })
        .join(", <br/>");
    } else {
      // message = `Record was ${item.action} by ${item.done_by?.name || "Unknown User"}`;
      message = `Deal Created`;
    }
    message = message.replace('(empty)', 'none')
    return {
      Id: id,
      Type: type,
      Message: message,
      Date: date,
      ActivityOwner: item.done_by?.id,
      ActivityOwnerName: item.done_by?.name,
    };
  });
}

    const handleFilterChange = (checkedValues) => {
    setSelectedActivityFilter(checkedValues);
    };
    const filterActivityPopOver=()=>{ 
        const filterOptions = [
        { value: 'Project_Date', label: 'Project Date' },
        { value: 'Closing_Date', label: 'Closing Date' },
        { value: 'Stage', label: 'Project Status' },
        { value: 'Notes', label: 'Notes' },
        { value: 'Roles', label: 'Project Roles' },
        // { value: 'BLUEPRINT', label: 'Blueprint' },
        // { value: 'COMMENT', label: 'Comments' },
        // { value: 'DEPENDENCY', label: 'Dependency' },
        // { value: 'TIME TRACKER', label: 'Time Tracks' },
        ]; 
        return (
        <div className="filter-options">
            <Checkbox.Group
            value={selectedActivityFilter}
            onChange={handleFilterChange}
            >
            <Space direction="vertical">
                {filterOptions.map(option => (
                <Checkbox key={option.value} value={option.value}>
                    {option.label}
                </Checkbox>
                ))}
            </Space>
            </Checkbox.Group>
        </div>
        );
    }

    const getUserThumbnailUrl = (zuid) => {
    return "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
    };
    const RenderChildren = (data) => {
        data = data?.data ? data?.data : data;
        let user = allUsers.find(d => d.zuid == data?.ActivityOwner || d.email == data?.ActivityOwner || d?.id === data?.ActivityOwner);
        return (
      data?.Message && (
        <Card
          size="small"
          style={{
            background: "#fff",
            borderRadius: 10,
            marginBottom: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
                className="User-Image"
                src={getUserThumbnailUrl(user?.zuid)}
              style={{cursor:'pointer', borderRadius: "50%", width: 40, height: 40 }}
                title={`${user?.full_name || ""}`}
                onClick={(e)=>{
                    e.preventDefault();
                    history.push({
                        pathname: `/setting/users/${user.id}/Users`,
                        state: { tab: "Users" },
                    });
                }}
            />
            <div style={{ flex: 1 }}>
              <div dangerouslySetInnerHTML={{ __html: data?.Message }} />
              <span style={{ fontSize: 12, color: "#888" }}>
                {modifyTimezoneString(data?.Date,"MM-DD-YYYY hh:mm A")}
            </span>
            </div>
        </div>
        </Card>
      )
        );
    };

    useEffect(() => {
      if (activitiyData) {
        const searchText = activityFilter.SearchText?.toLowerCase() || "";
        const skipPhrases = ["Project ID", "Notes ID", "Workdrive Folder ID", ];
        const filteredData = activitiyData.filter(item => {
          const ownerName = item.ActivityOwnerName?.toLowerCase() || "";
          const message = item.Message?.toLowerCase();
          const shouldSkip = skipPhrases.some(phrase =>
              message.includes(phrase.toLowerCase())
          );
          if (shouldSkip) return false;
          if (!searchText) return true;
            return ownerName.includes(searchText) || message.includes(searchText);
        });
        let temp = filteredData
            .filter(item => item?.Message)
            .map((item, ind) => {
            return {
                children: <RenderChildren id={"Timeline_"+ind} data={item} />,
            };
            });
        setItems(temp)
      }else{
        setItems([]);
      }
    }, [activitiyData, activityFilter.SearchText])

    return (
        <div className="activity-content" style={{height:"43rem"}}>
            <div className="header" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop:"10px" }}>
                {/* Search Box */}
                <Search
                placeholder="Input search text"
                allowClear={true}
                onSearch={(text) => setActivityFilter({ ...activityFilter, SearchText: text })}
                onChange={(e) => {
                    if (e.currentTarget.value === '') {
                    setActivityFilter({ ...activityFilter, SearchText: '' });
                    }
                }}
                className="inputForActivitySearch"
                style={{ width: 200 }}
                />
            
                {/* Filter Icon */}
                <div
                className="task_filter_box"
                style={{width: '35px', height: '32px', backgroundColor: 'rgb(254 254 255)',
                    border: '1px solid #cdcdcd', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', cursor: 'pointer'
                }}
                >
                <Popover
                    content={filterActivityPopOver}
                    title="Apply Filter"
                    trigger="click"
                    placement="bottom"
                    overlayClassName="Activity-Filter"
                    arrow={{ pointAtCenter: true }}
                >
                    <Badge color="#1677ff" style={{ left: "1em", top: "-4px" }}
                    count={selectedActivityFilter.length}
                    >
                    <FontAwesomeIcon style={{ color: 'rgb(124 139 173)', cursor: 'pointer' }}
                        icon={faFilter}
                    />
                    </Badge>
                </Popover>
                </div>
            </div>
      {/* 🎨 Timeline UI Updated */}
      <div className="activity-pipeline-container" style={{ marginTop: "15px" }}>
        <div
          className="activity-card"
          style={{ background: "#fff",borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",overflow: "hidden", }}>        
           {/* Body */}
                    <div
                    className="activity-card-body"
                    style={{
                        maxHeight: "67vh",
                        overflowY: "auto",
                        backgroundColor: "#f8f9fb",
                        padding: "20px 25px", 
                        scrollbarWidth: "thin",
                    }}
                    ref={bottomRef}
                    >
            {items?.length > 0 ? (
                        <ActivityTimeLine items={items} />
            ) : (
              <Empty description="No activities found" />
            )}
                    <div ref={bottomRef} />
                    </div>
                    </div>
                </div>
        </div>
    );
}

export default DealActivity;